export default __webpack_public_path__ + "static/media/pdv_1.83896503.png";